import { HTMLAttributes, JSX } from 'react'
import cn from 'classnames'
import styles from './TextBody.module.scss'

export interface TextBodyProps extends HTMLAttributes<HTMLElement> {
  id?: string
  size?: 's' | 'm' | 'l'
  weight?: 'bold' | 'regular'
  variant?: 'p' | 'span' | 'strong' | 'em' | 'b'
  className?: string
}

const TextBody = ({
  id,
  children,
  size = 'm',
  weight = 'regular',
  className,
  variant = 'p',
}: TextBodyProps): JSX.Element => {
  const getProps = () => ({
    ...(id && { id: `text-body-${id}` }),
    className: cn(
      styles.text,
      {
        [styles.bold]: weight === 'bold',
        [styles.regular]: weight === 'regular',
        [styles.s]: size === 's',
        [styles.m]: size === 'm',
        [styles.l]: size === 'l',
      },
      className
    ),
    children,
  })

  const variants = {
    p: <p {...getProps()} />,
    span: <span {...getProps()} />,
    strong: <strong {...getProps()} />,
    em: <em {...getProps()} />,
    b: <b {...getProps()} />,
  }

  return variants[variant]
}

export default TextBody
